module.exports = {
  eventCategory: 'Editor UI | Tool Menu | text banners',

  loadData: { eventAction: 'load_more' }
};
